<template>
    <div class="swiper-container-pagination" :id="id" :class="{nograb:!moreThanOne, 'single-picture': singlePic}">
        <div class="swiper-container" @click="openSingleGallery()">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
            <div class="swiper-pagination" v-if="moreThanOne"></div>
        </div>
        <div class="swiper-button-prev-taaf"><span class="icon-arrow-right"></span></div>
        <div class="swiper-button-next-taaf"><span class="icon-arrow-right"></span></div>
        <div class="zoom-gallery" @click="openGallery()">
            <span class="icon-zoom-swiper"></span>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Swiper from "swiper"

    export default {
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                pageSwiperInstance: null,
                imgList: [],
                moreThanOne: true,
                singlePic:false
            };
        },
        methods: {
            initSwiper() {

                let loop = true
                if (this.imgList.length === 1) {
                    loop = false
                    this.moreThanOne = false
                }

                this.pageSwiperInstance = new Swiper("#" + this.id + " .swiper-container", {
                    navigation: {
                        nextEl: "#" + this.id + " .swiper-button-next-taaf",
                        prevEl: "#" + this.id + " .swiper-button-prev-taaf",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: loop,
                    watchOverflow: true,
                    autoHeight: true,
                    on: {
                        init: () => {
                            setTimeout(() => {
                                this.checkLegend()
                            }, 100)
                        },
                        slideChangeTransitionEnd: () => {
                            setTimeout(() => {
                                this.checkLegend()
                            }, 100)
                        },
                    }
                });
            },
            checkLegend(){
                let $slideActive = $("#" + this.id + " .swiper-slide-active")
                let $elementLegend = $slideActive.find(".legend")
                let $elementCredit = $slideActive.find(".credits")

                let legende = $elementLegend.length ? $elementLegend[0].innerHTML : ""
                let credits = $elementCredit.length ? $elementCredit[0].innerHTML : ""

                if (legende === "" && credits === "") {
                    $("#" + this.id).addClass("no-legends")
                }else{
                    $("#" + this.id).removeClass("no-legends")
                }
            },
            getImgList() {

                $("#" + this.id + " .swiper-slide:not(.swiper-slide-duplicate) .img").each((index, element) => {

                    let style = element.currentStyle || window.getComputedStyle(element, false)
                    let bi = style.backgroundImage.slice(4, -1).replace(/"/g, "");

                    let $elementLegend = $(element).closest(".swiper-slide").find(".legend")
                    let $elementCredit = $(element).closest(".swiper-slide").find(".credits")

                    let legende = $elementLegend.length ? $elementLegend[0].innerHTML : ""
                    let credits = $elementCredit.length ? $elementCredit[0].innerHTML : ""

                    let join = legende && credits ? " - " : ""

                    let desc = legende + join + credits

                    this.imgList.push({
                        src: bi,
                        opts: {
                            caption: desc,
                            // thumb: "1_s.jpg"
                        }
                    })
                })

                if (this.imgList.length === 1){
                    this.singlePic = true
                }

            },
            openGallery() {
                let index = this.pageSwiperInstance.activeIndex - 1
                if (index === -1) {
                    index = 0
                }
                $.fancybox.open(this.imgList, {
                    loop: true
                }, index);
            },
            openSingleGallery(){
                if (this.singlePic){
                    this.openGallery()
                }
            }
        },
        mounted() {
            this.getImgList()
            this.initSwiper()
        },
        destroyed() {
        }
    };
</script>
